module.exports = __webpack_public_path__ + "static/media/agile.7dcedd81.png";